import { createSelector } from "reselect";
import { IStoreState } from "../../interfaces/IState";

export const getNotificationState = (state: IStoreState) => state.notifications;

export const getNotifications = createSelector(
  getNotificationState,
  notificationState => notificationState.notifications
);
